<template>
    <div v-if="hasCategories == true" class="flex flex-col gap-4">
        <h2>{{ $t("TopSearches.TopCategoriesHeader") }}</h2>
        <p v-if="hasParametricSearches">
            {{ parametricSearchText }}
            <NuxtLink v-for="search in parametricSearches" :key="search.url" :to="search.url">
                {{ search.label }}
            </NuxtLink>
        </p>
        <GridItems :items="props.categories?.Categories">
            <template #item="{ item: cat }">
                <div class="flex-1 font-bold">
                    <NuxtLink :to="cat.CategoryUrl">{{ cat.Name }}</NuxtLink>
                </div>
                <div>{{ formatPartsInStock(cat.PartsInStock) }}</div>
                <div>{{ formatTotalParts(cat.TotalParts) }}</div>
            </template>
        </GridItems>
    </div>
</template>
<script setup lang="ts">
const { t } = useI18n();

const props = defineProps<{ categories?: ManufacturerCategories }>();

const parametricSearchText = computed(() => {
    return t("Manufacturer.CategoryParametricSearch");
});

const parametricSearches = computed(() => {
    const searches = props.categories?.ParametricSearches ?? [];

    return searches
        .map((search) => {
            const [filter] = search.Filters;
            if (!filter) return;

            const queryParams = new URLSearchParams([[filter.PartSpecificationId.toString(), filter.Value]]);

            return {
                url: [search.CategoryUrl, queryParams.toString()].join("?"),
                label: [filter.Value, search.CategoryName].join(" "),
            };
        })
        .filter((search) => search !== undefined);
});

const hasCategories = computed(
    () => Array.isArray(props.categories?.Categories) && props.categories.Categories.length > 0
);

const hasParametricSearches = computed(() => parametricSearches.value.length > 0);

function formatPartsInStock(no?: number): string {
    return t("Global.PartsInStock", [formatNumber(no)]);
}

function formatTotalParts(no?: number): string {
    return t("ProductSeries.TotalProducts", [formatNumber(no)]);
}
</script>
